import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../utils/meta";

export default function NotFound() {
  useEffect(() => {
    setPageMeta({
      title: "Page Not Found",
      description: "That page doesn't exist.",
      noindex: true,
    });
  }, []);

  return (
    <main className="not-found-page">
      <h1>404, Page not found</h1>
      <p>That page doesn't exist. Try one of these instead:</p>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/gallery">All Settings</Link></li>
        <li><Link to="/about">About</Link></li>
      </ul>
    </main>
  );
}
